module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#shortform",
      toString: function () {
        return this.url;
      }
    }